import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  padding: (p) => p.spacing(1),
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(0.5),
};
